export const API_VERSION = '1.6';
export const TENANT_ID = 'myorganization';
export const GRAPH_URL = 'https://graph.windows.net/';
export const GRAPH_SCOPE = 'User.Read';
export const GRAPH_URL_MICROSOFT_BETA = 'https://graph.microsoft.com/beta';
//# sourceMappingURL=graph-api.config.js.map